const actionTypes = {
  SET_DEFAULT_CSS_LIBRARY: 'SET_DEFAULT_CSS_LIBRARY',
};

export default actionTypes;
